import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VerticalAlignment, VerticalAlignmentClass, VerticalAlignmentValueClass } from "../../../../Constant";
import { ALIGNMENT_DATA } from "../../../../Data/UiKit/Grid";
import { DynamicVerticalAlignment } from "./DynamicVerticalAlignment";
import { StaticVerticalAlignment } from "./StaticVerticalAlignment";
import GridCommonCardFooter from "../Common/GridCommonCardFooter";

const VerticalAlignmentCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={VerticalAlignment} span={ALIGNMENT_DATA} />
        <CardBody className="grid-showcase mb-0">
          <Row>
            <StaticVerticalAlignment />
            <DynamicVerticalAlignment />
          </Row>
        </CardBody>
        <GridCommonCardFooter className={VerticalAlignmentClass} valueClass={VerticalAlignmentValueClass} />
      </Card>
    </Col>
  );
};

export default VerticalAlignmentCart;
